import { render } from "./Why-Us.vue?vue&type=template&id=bce967e4&scoped=true"
import script from "./Why-Us.vue?vue&type=script&lang=js"
export * from "./Why-Us.vue?vue&type=script&lang=js"

import "./Why-Us.vue?vue&type=style&index=0&id=bce967e4&lang=scss&scoped=true"

import exportComponent from "/Users/amina/Desktop/streamup_amina/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce967e4"]])

export default __exports__